export const songList = [
  {
    id: "hey_jude",
    title: "Hey Jude",
    artist: "The Beatles",
    filename: "hey_jude.json",
    image: "/images/Hey_Jude_single.webp",
  },
  {
    id: "led_zeppelin_whole_lotta_love",
    title: "Whole Lotta Love",
    artist: "Led Zeppelin",
    filename: "led_zeppelin_whole_lotta_love.json",
    image: "/images/whole-lotta-love.jpeg",
  },
  {
    id: "nirvana_smells_like_teen_spirit",
    title: "Smells Like Teen Spirit",
    artist: "Nirvana",
    filename: "nirvana_smells_like_teen_spirit.json",
    image: "/images/smells-like-teen-spirit.jpg",
  },
  {
    id: "pink_floyd_another_brick_in_the_wall",
    title: "Another Brick In The Wall",
    artist: "Pink Floyd",
    filename: "pink_floyd_another_brick_in_the_wall.json",
    image: "/images/another-brick-in-the-wall.webp",
  },
  {
    id: "queen_we_will_rock_you",
    title: "We Will Rock You",
    artist: "Queen",
    filename: "queen_we_will_rock_you.json",
    image: "/images/we-will-rock-you.png",
  },
]
